import _, { isEmpty, isEqual, isNil } from 'lodash';
import { BindAll } from 'lodash-decorators';
import React from 'react';
// @ts-ignore
import keydown from 'react-keydown';
import { connect } from 'react-redux';
import MinimizableItem from 'src/components/DraggableContainer/MinimizableItem';
import GridErrorBoundary from 'src/components/ErrorBoundary/GridErrorBoundary';
import LoadingMask from 'src/components/LoadingMask/LoadingMask';
import AgPivot, { AgPivot as IAgPivot } from 'src/components/Mfp/Pivot/AgPivot';
import PivotConfigurator from 'src/components/Mfp/PivotConfigurator/PivotConfigurator';
import { ConfigGroup, ConfigItem } from 'src/components/Mfp/PivotConfigurator/PivotConfigurator.types';
import {
  PivotOptions,
  getAvailableListing,
  getEffeciveGroups,
  getGroupFromConfigItem,
  getUnFilteredGroupFromConfigItem,
  DimensionItem,
} from 'src/components/Mfp/PivotConfigurator/utils';
import { PivotCell, CELL_TAG_LOCKED, CELL_TAG_FROZEN } from 'src/pivot/PivotCell';
import PivotConfig from 'src/pivot/PivotConfig';
import { configItemToSimpleFavorite, FavoritesEntry } from 'src/services/Favorites';
import './_visualize-summary-pivot.scss';
import { mapDispatchToProps, mapStateToProps } from './visualize-summary-pivot-ag.container';
import { VisualizeSummaryPivotProps, VisualizeSummaryPivotState } from './visualize-summary-pivot-ag.types';
import { API_BASE_URL } from 'src/state/ViewConfig/ViewConfig.slice';
import { isScopeNotReady } from 'src/state/scope/Scope.types';
import { toast } from 'react-toastify';
import { ReportStatus } from 'src/services/Reports.client';
import MacroSummaries from 'src/components/Mfp/MacroSummaries/MacroSummaries';
import { CONTEXT_PENDING, CONTEXT_READY } from 'src/state/workingSets/workingSets.types';
import { getCellStateFromCells } from 'src/pivot/PivotCells.utils';
import { VisualizeContextMenu } from 'src/components/VisualizeContextMenu/VisualizeContextMenu';
import EditableChartHooks from 'src/components/Mfp/EditableChart/EditableChartHooks';
import { AxiosError } from 'axios';
import { withTranslation } from 'react-i18next';
import { makeMfpScopeSensitive } from 'src/components/higherOrder/MfpScopeSensitive';
import serviceContainer from 'src/ServiceContainer';
import MfpSubheader from 'src/components/Mfp/MfpSubheader/MfpSubheader';
import { TextField, Button, Paper } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import WarningIcon from '@material-ui/icons/Warning';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Group } from 'src/pivot/Group';
import { AVAILABLE } from 'src/utils/Domain/Constants';
import {
  CellClickedEvent
} from '@ag-grid-community/core';
import TemplateModalWithButton from 'src/components/TemplateModalWithButton/TemplateModalWithButton';

@BindAll()
export class VisualizeSummaryPivotAg extends React.Component<VisualizeSummaryPivotProps, VisualizeSummaryPivotState> {
  public constructor(props: VisualizeSummaryPivotProps) {
    super(props);
    this.state = VisualizeSummaryPivotAg.getDerivedStateFromProps(props, {
      viewParams: props.viewParams,
      isSaving: false,
      isConfigModalOpen: false,
      allAvailableListing: [],
      availableGroup: [],
      rowGroup: [],
      colGroup: [],
      contextItems: [],
      groups: [
        {
          id: AVAILABLE,
          name: 'Dimension',
          children: [],
        },
        {
          id: 'rows',
          name: 'Rows',
          children: [],
        },
        {
          id: 'columns',
          name: 'Columns',
          children: [],
        },
      ],
    });
  }

  public pivot: IAgPivot | undefined;

  public static getDerivedStateFromProps(props: VisualizeSummaryPivotProps, state: VisualizeSummaryPivotState) {
    const newState = { ...state };
    const mainConfig = props.mainConfig;
    const settings = props.settings;
    if (!mainConfig || !settings || isScopeNotReady(mainConfig)) {
      return newState;
    }
    newState.viewParams = props.viewParams;

    const maybeAlternateDims = [
      props.viewParams!.rows.find((rd) => rd.hierarchy),
      props.viewParams!.columns.find((cd) => cd.hierarchy),
    ].filter((dd) => !!dd);

    newState.allAvailableListing = getAvailableListing(mainConfig, settings, maybeAlternateDims as DimensionItem[]);

    if (newState.favoriteValue) {
      // Do nothing
    } else if (newState.viewParams) {
      const viewParams = newState.viewParams;

      if (state.pivotConfig) {
        newState.availableGroup = state.availableGroup;
        newState.rowGroup = state.rowGroup;
        newState.colGroup = state.colGroup;
      } else {
        const effective = getEffeciveGroups(newState.allAvailableListing, viewParams);
        newState.availableGroup = effective.available;
        newState.rowGroup = effective.row;
        newState.colGroup = effective.column;
      }
    } else {
      newState.availableGroup = newState.allAvailableListing;
      newState.rowGroup = [];
      newState.colGroup = [];
    }
    return newState;
  }

  public toggleLock() {
    const { isLockToggled, onUnlockAllClick, scopeId } = this.props;
    if (isLockToggled && scopeId) {
      if (onUnlockAllClick) {
        onUnlockAllClick(this, serviceContainer.axios, scopeId);
      }
    }
    this.pivot!.setFocusedCell();
  }

  public onSaveWorkingPlan() {
    const { saveWorkingPlan, scopeId } = this.props;

    if (saveWorkingPlan && scopeId) {
      this.setState({
        isSaving: true,
      });
      saveWorkingPlan(serviceContainer.axios, scopeId).then(() => {
        this.setState({
          isSaving: false,
        });
      });
    }
  }

  /*** KEYBOARD EVENTS ***/
  // undo grid
  @keydown('ctrl+z', 'meta+z')
  public keyUndo(e: React.KeyboardEvent) {
    // check for edit state? can this affect the inputs?
    e.preventDefault();
    e.stopPropagation();
    this.onClickUndo();
    this.pivot!.setFocusedCell();
  }

  // redo grid
  @keydown('ctrl+y', 'meta+y')
  public keyRedo(e: React.KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.onClickRedo();
    this.pivot!.setFocusedCell();
  }

  // lock cell
  @keydown('ctrl+g')
  public keyLock(e: React.KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();

    const pivot = this.pivot;
    let cells: PivotCell[] = [];

    if (pivot) {
      cells = pivot.getSelectedCells();
    }

    const isUnlockable = cells.filter((cell: PivotCell) => cell.hasTag(CELL_TAG_LOCKED)).length === cells.length;

    if (isUnlockable) {
      this.relaxCells();
    }
    this.lockCells();
  }

  // freeze cell
  @keydown('ctrl+e')
  public keyFreeze(e: React.KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();

    const pivot = this.pivot;
    let cells: PivotCell[] = [];

    if (pivot) {
      cells = pivot.getSelectedCells();
    }

    const isUnfreezeable = cells.filter((cell: PivotCell) => cell.hasTag(CELL_TAG_FROZEN)).length === cells.length;

    if (isUnfreezeable) {
      this.relaxCells();
    }
    this.freezeCells();
  }

  @keydown('ctrl+d')
  public keyRelax() {
    this.relaxCells();
  }

  public async onClickDownload() {
    const { scopeId, pivotName } = this.props;

    // only one download is allowed at a time
    if (this.state.xlsDownloadStatus?.status === CONTEXT_PENDING) {
      return;
    }
    const tokenValue = serviceContainer.lastBearerToken();
    const requestGenerateReportUrl = `${API_BASE_URL}/context/${scopeId}/pivot/${pivotName}/export?token=${tokenValue}`;
    try {
      await serviceContainer.axios.get<ReportStatus>(requestGenerateReportUrl).then((rep) => {
        this.setState({
          xlsDownloadStatus: {
            id: rep.data.id,
            status: CONTEXT_PENDING,
          },
        });
      });
    } catch (e) {
      const error = e as AxiosError;
      const reportDownloadErrorMessage = 'An error has occued downloading your report';

      const errorPayload =
        error.response && error.stack && typeof error.response === 'object' && typeof error.stack === 'string'
          ? error.stack.concat(JSON.stringify(error.response))
          : error.stack;

      serviceContainer.loggingService.error(reportDownloadErrorMessage, errorPayload);
      toast.error(reportDownloadErrorMessage, {
        position: toast.POSITION.TOP_LEFT,
      });
    }
  }

  public onClickUndo() {
    const { scopeId, onClickUndo } = this.props;
    if (onClickUndo && scopeId) {
      onClickUndo(scopeId).then(() => this.pivot!.setFocusedCell());
    }
  }

  public onClickRedo() {
    const { scopeId, onClickRedo } = this.props;
    if (onClickRedo && scopeId) {
      onClickRedo(scopeId).then(() => this.pivot!.setFocusedCell());
    }
  }

  public freezeCells = () => {
    const pivot = this.pivot;
    let cells: PivotCell[] = [];
    if (!pivot) {
      return;
    }

    cells = pivot.getSelectedCells();

    pivot.state.manager
      .lockCells(cells)
      .then((isGlobalLock) => {
        if (pivot.props.updateLockState) {
          return pivot.props.updateLockState(pivot.props.config.scopeId, isGlobalLock);
        }
        return false;
      })
      .then(() => {
        pivot.refreshCells();
        pivot.setState({ isEditing: false }, () => {
          pivot.gridApi?.addEventListener('cellsReturned', this.updateContextMenu);
        });
      });
  };

  public lockCells = () => {
    const pivot = this.pivot;
    let cells: PivotCell[] = [];
    if (!pivot) {
      return;
    }
    cells = pivot.getSelectedCells();

    pivot.state.manager
      .constrainCells(cells)
      .then((isGlobalLock) => {
        if (pivot.props.updateLockState) {
          return pivot.props.updateLockState(pivot.props.config.scopeId, isGlobalLock);
        }
        return false;
      })
      .then(() => {
        pivot.refreshCells();
        pivot.setState({ isEditing: false }, () => {
          pivot.gridApi?.addEventListener('cellsReturned', this.updateContextMenu);
        });
      });
  };

  public relaxCells = () => {
    const pivot = this.pivot;
    let cells: PivotCell[] = [];
    if (!pivot) {
      return;
    }
    cells = pivot.getSelectedCells();

    pivot.state.manager
      .relaxCells(cells)
      .then((isGlobalLock) => {
        if (pivot.props.updateLockState) {
          return pivot.props.updateLockState(pivot.props.config.scopeId, isGlobalLock);
        }
        return false;
      })
      .then(() => {
        pivot.refreshCells();
        pivot.setState({ isEditing: false }, () => {
          pivot.gridApi?.addEventListener('cellsReturned', this.updateContextMenu);
        });
      });
  };

  public onLayoutManagerOpen() {
    this.setState({ isConfigModalOpen: true });
  }

  public onLayoutManagerClose() {
    this.setState({ isConfigModalOpen: false });
  }

  public onLayoutManagerSubmit() {
    const mainConfig = this.props.mainConfig;
    if (!mainConfig || isScopeNotReady(mainConfig)) {
      return;
    }

    const levelsMap = _.keyBy(_.flatMap(mainConfig.levels), 'id');
    const availalbe = this.state.groups[0].children;
    const rows = this.state.groups[1].children;
    const columns = this.state.groups[2].children;
    const rGroups: Group[] = [];
    const cGroups: Group[] = [];

    for (const row of rows!) {
      rGroups.push(getUnFilteredGroupFromConfigItem(row, levelsMap));
    }
    for (const col of columns!) {
      cGroups.push(getUnFilteredGroupFromConfigItem(col, levelsMap));
    }

    const pivotConfig = new PivotConfig({
      scopeId: this.props.scopeId,
      rows: rGroups,
      columns: cGroups,
      relocalizeCurrency: this.state.viewParams?.relocalizeCurrency,
    });

    this.setState(
      {
        pivotConfig,
        rowGroup: rows as ConfigGroup[],
        colGroup: columns as ConfigGroup[],
        availableGroup: availalbe as ConfigGroup[],
        isConfigModalOpen: false,
      },
      () => {
        this.updateContextMenu();
      }
    );
  }

  componentDidUpdate(prevProps: VisualizeSummaryPivotProps, prevState: VisualizeSummaryPivotState) {
    // This is here because we store the download state while it's loading
    if (
      prevProps.gridAsyncState !== this.props.gridAsyncState ||
      !isEqual(prevState.xlsDownloadStatus, this.state.xlsDownloadStatus)
    ) {
      this.updateContextMenu();
    }

    if (this.state.xlsDownloadStatus) {
      try {
        const authToken = serviceContainer.lastBearerToken();
        this.props.reports.forEach((rep) => {
          if (rep.id === this.state.xlsDownloadStatus?.id && rep.status === CONTEXT_READY) {
            this.setState(
              {
                xlsDownloadStatus: undefined,
              },
              () => (window.location.href = `${API_BASE_URL}/drop/${rep.id}?token=${authToken}`)
            );
          }
        });
      } catch (e) {
        toast.error('An error has occued downloading your report');
        serviceContainer.loggingService.error('An error has occued downloading your report');
      }
    }

    // Need to initialize these
    const [a, r, c] = this.state.groups;
    if (isEmpty(a.children) &&
    isEmpty(r.children) &&
    isEmpty(c.children) &&
    this.props.mainConfig &&
    this.props.settings &&
    this.props.scopeReady
  ) {
      let filteredRows: ConfigGroup[] = [];
      let filteredCols: ConfigGroup[] = [];
      // alwaysHidden items mess up the drag & drop ordering
      if (!isEmpty(this.state.rowGroup)) {
        filteredRows = this.state.rowGroup.map((row) => ({
          ...row,
          children: row.children?.filter((child) => !child.alwaysHidden),
        }));
      }
      if (!isEmpty(this.state.colGroup)) {
        filteredCols = this.state.colGroup.map((col) => ({
          ...col,
          children: col.children?.filter((child) => !child.alwaysHidden),
        }));
      }

      const initialStateGroups = [
        {
          id: AVAILABLE,
          name: 'Dimension',
          children: _.cloneDeep(this.state.availableGroup) || [],
        },
        {
          id: 'rows',
          name: 'Rows',
          children: _.cloneDeep(filteredRows) || [],
        },
        {
          id: 'columns',
          name: 'Columns',
          children: _.cloneDeep(filteredCols) || [],
        },
      ];
      this.setState({ groups: initialStateGroups })
    }
  }

  public onFavoritesAdd = (_event: React.ChangeEvent<{}>, newValue: string | null) => {
    if (!newValue) {
      return;
    }

    const { groupId, addToFavorites } = this.props;
    const rows = this.state.groups[1];
    const columns = this.state.groups[2];

    const faveOpts: PivotOptions = {
      rows: rows.children!.map((child) => configItemToSimpleFavorite(child)),
      columns: columns.children!.map((child) => configItemToSimpleFavorite(child)),
    };

    if (addToFavorites) {
      const fe: FavoritesEntry = {
        key: newValue,
        group: groupId,
        value: faveOpts,
      };
      addToFavorites(serviceContainer.axios, fe);
    }
    this.setState({ favoriteValue: newValue });
  };

  public onFavoritesChange = (
    _event: React.ChangeEvent<{}>,
    newValue: { value: string; text: string } | string | null
  ) => {
    if (!newValue) {
      return;
    }

    const selectedKey = typeof newValue === 'string' ? newValue : newValue.value;

    const keys = _.keyBy(this.props.favorites, 'key');
    const faveEntry: FavoritesEntry = keys[selectedKey];

    if (!faveEntry) {
      return;
    }

    const effective = getEffeciveGroups(this.state.allAvailableListing, faveEntry.value);

    this.setState({
      favoriteValue: selectedKey,
      rowGroup: effective.row,
      colGroup: effective.column,
      availableGroup: effective.available,
    });

    this.setState({
      groups: [
        { id: 'available', name: 'Dimension', children: _.cloneDeep(effective.available) || [] },
        { id: 'rows', name: 'Rows', children: _.cloneDeep(effective.row) || [] },
        { id: 'columns', name: 'Columns', children: _.cloneDeep(effective.column) || [] },
      ],
    });
  };

  public onPivotChange() {
    this.updateContextMenu();
  }

  public handleSetPivot = (pivot: IAgPivot) => {
    this.pivot = pivot;
  };

  public handleToggleRowGroup(params: CellClickedEvent) {
    const mainConfig = this.props.mainConfig;

    const columnRowIndex = parseFloat(params.column.getId());
    const memberId = params.data[columnRowIndex].id;

    if (!mainConfig || isScopeNotReady(mainConfig) || !memberId) {
      return;
    }
    const resursiveDisable = (gp: ConfigItem) => {
      gp.disabled = true;
      if (gp.children && !isEmpty(gp.children)) {
        gp.children.forEach(resursiveDisable);
      }
    }
    function recursiveFind(gp: ConfigItem, memberId: string): boolean | undefined {
      if (gp.id === memberId) {
        gp.disabled = false; // the clicked parent should always been shown

        // figure out if all children are disabled (and therefore aren't shown);
        // if they're all off, when the user clicks the expand button we expand them all
        const allChildrenDisabled = gp.children?.every(c => c.disabled);
        if (allChildrenDisabled) {
          // Only apply the change to a single level, don't go any deeper
          gp.children?.forEach(c => c.disabled = !allChildrenDisabled);
        } else {
          // disabled all children and deeper recursively
          gp.children?.forEach(resursiveDisable);
        }

        gp.children?.forEach(c => c.disabled = !allChildrenDisabled);
        return allChildrenDisabled;
      }

      if (!gp.children) {
        return;
      }
      gp.children.forEach((nestedChild) => {
        if (nestedChild.children && nestedChild.children.length > 0) {
          recursiveFind(nestedChild, memberId);
        }
      });
    }

    const levelsMap = _.keyBy(_.flatMap(mainConfig.levels), 'id');
    const availalbe = this.state.groups[0].children;
    const rows = this.state.groups[1].children;
    const columns = this.state.groups[2].children;
    const rGroups: Group[] = [];
    const cGroups: Group[] = [];

    rows![columnRowIndex].children?.forEach(r => recursiveFind(r, memberId));

    for (const row of rows!) {
      rGroups.push(getUnFilteredGroupFromConfigItem(row, levelsMap));
    }
    for (const col of columns!) {
      cGroups.push(getUnFilteredGroupFromConfigItem(col, levelsMap));
    }

    const pivotConfig = new PivotConfig({
      scopeId: this.props.scopeId,
      rows: rGroups,
      columns: cGroups,
      relocalizeCurrency: this.state.viewParams?.relocalizeCurrency,
    });

    // modify the ag-grid cell state back so we can render the expand arrow correctly
    const loc = AgPivot.getRowColFromParams(params);
    const currentCell = params.data[loc.col] as PivotCell;
    currentCell.tags.push()


    this.setState(
      {
        pivotConfig,
        rowGroup: rows as ConfigGroup[],
        colGroup: columns as ConfigGroup[],
        availableGroup: availalbe as ConfigGroup[],
        isConfigModalOpen: false,
      },
      () => {
        this.updateContextMenu();
      }
    );
  }

  public updateContextMenu() {
    const pivot = this.pivot;
    let cells: PivotCell[] = [];

    if (pivot) {
      cells = pivot.getSelectedCells();
    }

    const cellState = getCellStateFromCells(cells);

    const contextItems = (
      <VisualizeContextMenu
        hasEditableRevision={this.props.hasEditableRevision}
        cellState={cellState}
        favoritesLoading={this.state.xlsDownloadStatus?.status === CONTEXT_PENDING}
        gridAsyncState={this.props.gridAsyncState}
        availableGroup={this.state.availableGroup}
        handleClickUndo={this.onClickUndo}
        handleClickRedo={this.onClickRedo}
        handleClickLayoutManagerOpen={this.onLayoutManagerOpen}
        handleClickDownload={this.onClickDownload}
        freezeCells={this.freezeCells}
        lockCells={this.lockCells}
        relaxCells={this.relaxCells}
      />
    );

    this.setState({ contextItems });
  }

  handleDimensionChange = () => {
    if (isNil(this.props.onforceRefreshGrid)) {
      return;
    }

    this.props.onforceRefreshGrid();
  };

  public handleOnChangeGroups = (newGroups: ConfigItem[]) => {
    this.setState({
      groups: newGroups
    })
  }

  public render() {
    const mainConfig = this.props.mainConfig;
    const { t, onSetPivotCollapsed, isMfpPivotCollapsed } = this.props;
    if (isScopeNotReady(mainConfig) || !this.props.scopeReady) {
      return (
        <Paper className="visualize-summary-pivot-uninitialized">
          <WarningIcon className="warning-icon" />
          Scope not ready, please wait while your scope is prepared
        </Paper>
      );
    }
    if (!mainConfig) {
      return <React.Fragment />;
    }
    if (!this.props.initialized && !this.props.isFetchingScope && this.props.scopeReady) {
      return (
        <Paper className="visualize-summary-pivot-uninitialized">
          <WarningIcon className="warning-icon" />
          Plan not initialized. Please Initialize the Plan
        </Paper>
      );
    }

    const levelsMap = _.keyBy(_.flatMap(mainConfig.levels), 'id');
    const viewParams = this.state.viewParams;
    if (!viewParams) {
      return <React.Fragment />;
    }

    const rowDimensions = viewParams.rows.map((entry) => entry.dimension);
    const colDimensions = viewParams.columns.map((entry) => entry.dimension);
    const dimRowKeyToIndex = _.mapValues(
      _.keyBy(
        _.map(rowDimensions, (d, i) => ({ d, i })),
        'd'
      ),
      'i'
    );
    const dimColKeyToIndex = _.mapValues(
      _.keyBy(
        _.map(colDimensions, (d, i) => ({ d, i })),
        'd'
      ),
      'i'
    );

    let rowMemberInfo: ConfigGroup[] = this.state.rowGroup;
    let colMemberInfo: ConfigGroup[] = this.state.colGroup;

    rowMemberInfo = _.sortBy(rowMemberInfo, (g) => dimRowKeyToIndex[g.id]);
    colMemberInfo = _.sortBy(colMemberInfo, (g) => dimColKeyToIndex[g.id]);

    const pivotRows = rowMemberInfo.map((mi) => getGroupFromConfigItem(mi, viewParams, levelsMap));
    const pivotCols = colMemberInfo.map((mi) => getGroupFromConfigItem(mi, viewParams, levelsMap));

    const pivotConfig = new PivotConfig({
      scopeId: this.props.scopeId,
      rows: pivotRows,
      columns: pivotCols,
      relocalizeCurrency: viewParams.relocalizeCurrency,
    });

    const keys = Object.keys(_.keyBy(this.props.favorites, 'key'));
    const faveOptions = keys.map((key) => ({ value: key, text: key }));

    return (
      <div className="visualize-summary-pivot">
        <MfpSubheader
          title={viewParams.title || ''}
          lockToggleParams={{
            active: this.props.isLockToggled,
            onClick: this.toggleLock,
            hidden: !this.props.hasEditableRevision,
          }}
        />

        <div className="draggable-container">
          {this.props.viewParams?.editableChart ? (
            <EditableChartHooks viewParams={this.props.viewParams.editableChart} />
          ) : (
            <MacroSummaries />
          )}
          <MinimizableItem className="mfp-ag-pivot-grid" title="" optionChildren={this.state.contextItems} disableMinimize={true} onSetPivotCollapsed={onSetPivotCollapsed} isMinimized={isMfpPivotCollapsed}>
            <GridErrorBoundary errorTitle={'Something has gone wrong with the grid'}>
              <AgPivot
                config={this.state.pivotConfig || pivotConfig}
                onDataChange={this.onPivotChange}
                onSelectionChange={this.onPivotChange}
                onMount={this.onPivotChange}
                handleDownloadXLS={this.onClickDownload}
                handleSetPivot={this.handleSetPivot}
                handleToggleRowGroup={this.handleToggleRowGroup}
              />
            </GridErrorBoundary>
          </MinimizableItem>
        </div>
{this.state.isConfigModalOpen && (
  <TemplateModalWithButton
    title="Layout Manager"
    // open via isConfigModalOpen – dummy trigger
    buttonComponent={<span style={{ display: 'none' }} />}
    openOverride={true}
    showSubmit={true}
    onSubmit={this.onLayoutManagerSubmit}
    onCancel={this.onLayoutManagerClose}
    paperClassName="layout-manager-modal"
    customSubmitComponent={({ submit, cancel }) => (
      <div className="layout-footer">
        <div className="favorite-title">Save as {t('favorite')}</div>
        <Autocomplete
          options={faveOptions}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.text)}
          onChange={(_, newValue) => {
            if (typeof newValue === 'string') {
              // User typed something and pressed enter
              this.onFavoritesAdd(_, newValue);
            } else if (newValue && !faveOptions.some((opt) => opt.value === newValue.value)) {
              // User selected an "Add" option
              this.onFavoritesAdd(_, newValue.value);
            } else {
              // Standard selection change
              this.onFavoritesChange(_, newValue?.value || '');
            }
          }}
          value={faveOptions.find((opt) => opt.value === this.state.favoriteValue) || undefined}
          renderInput={(params) => (
            <TextField
              {...params}
              className="text-field"
              variant="outlined"
              placeholder="<Type favorite name>"
              InputProps={{
                ...params.InputProps,
                endAdornment: <ArrowDropDownIcon />,
              }}
            />
          )}
          className="favorites-dropdown"
              freeSolo //  Allows new input values
          disableClearable
          filterOptions={(options, params) => {
            const { inputValue } = params;
            const filtered = options.filter((option) =>
              option.text.toLowerCase().includes(inputValue.toLowerCase())
            );
                // making the Add option when you type
                if (inputValue !== '' && !options.some((opt) => opt.text.toLowerCase() === inputValue.toLowerCase())) {
              filtered.push({
                text: `Add "${inputValue}"`,
                value: inputValue,
              });
            }

            return filtered;
          }}
          selectOnFocus
          openOnFocus
          clearOnBlur
        />
        <Button className="layout-cancel-button button" onClick={cancel}>
          CANCEL
        </Button>
        <Button className="button layout-submit-modal-button" onClick={submit}>
          SUBMIT
        </Button>
      </div>
    )}
  >
    <div className="layout-modal-body">
      <PivotConfigurator
        available={this.state.availableGroup}
        rows={this.state.rowGroup}
        columns={this.state.colGroup}
        settings={this.props.settings}
        groups={this.state.groups}
        onChangeGroups={this.handleOnChangeGroups}
      />
    </div>
  </TemplateModalWithButton>
)}

        {this.state.isSaving && <LoadingMask />}
      </div>
    );
  }
}

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(makeMfpScopeSensitive(withTranslation(null, { withRef: true })(VisualizeSummaryPivotAg)));
